import {observable, action} from 'mobx';

class dshStore{
    // 环境参数数据
    @observable.shallow environments = [];

    @action setEnvironments(environments) {
        this.environments = environments;
    }

    // 传感器数据
    @observable.shallow sensors = [];

    @action setSensors(sensors) {
        this.sensors = sensors;
    }


    // 工程项目
    @observable.shallow engineerings = [];

    @action setEngineerings(engineerings) {
        this.engineerings = engineerings;
    }

    // 项目展示
    @observable.shallow projects = [];

    @action setProjects(projects) {
        this.projects = projects;
    }

    // 地图数据
    @observable.shallow mapdata = [];

    @action setMapdata(mapdata) {
        this.mapdata = mapdata;
    }
}

export default new dshStore();